window.plausible = window.plausible || function() { (window.plausible.q = window.plausible.q || []).push(arguments) }

document.addEventListener("turbolinks:load", function(event) {
  plausible('pageview')
})
